import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Image from 'next/image'

import { Row, Rows, Column } from '@/components/layout'
import { Text } from '@/components/common'
import arrowsIconImg from '@/assets/buy-flow/right-side/arrows-icon.png'
import filesImg from '@/assets/pricing/list-icons/files.png'
import dataCaptureImg from '@/assets/pricing/list-icons/data-capture.png'
import unlimitedSupportImg from '@/assets/pricing/list-icons/unlimited-support.png'
import expensesImg from '@/assets/pricing/list-icons/expenses.png'
import filterImg from '@/assets/pricing/list-icons/filter.png'
import fileSharingImg from '@/assets/pricing/list-icons/file-sharing.png'
import encryptionImg from '@/assets/pricing/list-icons/encryption.png'
import accessibleImg from '@/assets/pricing/list-icons/accessible.png'
import helpCenterImg from '@/assets/pricing/list-icons/help-center.png'

import styles from './CheckoutSideChooseModules.module.scss'

const featureSet = [
  { name: 'files', img: filesImg },
  { name: 'data-capture', img: dataCaptureImg },
  { name: 'unlimited-support', img: unlimitedSupportImg },
  { name: 'expenses', img: expensesImg },
  { name: 'filter', img: filterImg },
]

const featureSet2 = [
  { name: 'file-sharing', img: fileSharingImg },
  { name: 'encryption', img: encryptionImg },
  { name: 'accessible', img: accessibleImg },
  { name: 'help-center', img: helpCenterImg },
]

const FeatureList = ({ features }) => (
  <ul className={styles.featureList}>
    {features.map(({ name, img }) => (
      <li key={name}>
        <Image
          alt={name}
          src={img}
        />
        <FormattedMessage id={`pages.signUp.form.selectPlan.side.features.${name}`} />
      </li>))}
  </ul>
)

FeatureList.propTypes = {
  features: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    img: PropTypes.shape({}), // StaticImageData?
  })).isRequired,
}

export default function CheckoutSideChooseModules({ planDifferencesId }) {
  return (
    <Column center className={styles.background}>
      <Rows>
        <Image
          alt=""
          className={styles.neatLogo}
          id={planDifferencesId}
          src={arrowsIconImg}
        />
        <Text.H2 className={styles.header} onTint responsive={false}>
          Enhance your base subscription
        </Text.H2>
      </Rows>
      <Row className={styles.modulesRow}>
        <Column>
          <div className={styles.moduleDetails}>
            <h3>VIP Service</h3>
            <p>Everything you need, plus premium help from our specialized support team.</p>
            <ul>
              <li>1:1 training guided by Neat Experts</li>
              <li>Dedicated support team so you can skip the line</li>
              <li>Early access to new features</li>
              <li>Exclusive offers</li>
            </ul>
          </div>
        </Column>
        <Column>
          <div className={styles.moduleDetails}>
            <h3>Automated Insights</h3>
            <p>Gain valuable insights into your finances with real-time accounting and expense reporting.</p>
            <ul>
              <li>Import bank account activity</li>
              <li>Automatic accounting reports</li>
              <li>Real-time insights and trends</li>
              <li>Pair receipts with expenses</li>
              <li>Send custom invoices</li>
            </ul>
          </div>
        </Column>
      </Row>
      <Rows>
        <Image
          alt=""
          className={styles.neatLogo}
          src={arrowsIconImg}
        />
        <Text.H2 className={styles.header} onTint responsive={false}>Base Includes</Text.H2>
      </Rows>
      <Row className={styles.featuresRow} gap={0}>
        <Column>
          <FeatureList features={featureSet} />
        </Column>
        <Column className={styles.bottomListColumn}>
          <FeatureList features={featureSet2} />
        </Column>
      </Row>
    </Column>
  )
}

CheckoutSideChooseModules.propTypes = {
  planDifferencesId: PropTypes.string.isRequired,
}
